/** Markdown down to the words, for a line that is clamped rather than rendered: a card, a title, a reply. */
export function plainText(markdown) {
    return markdown
        .replace(/!\[[^\]]*\](\([^)]*\)?)?/g, "")
        .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1")
        .replace(/^\s*(#{1,6}|>|[-*+]|\d+\.)\s+/gm, "")
        .replace(/(?<![\w\\])(\*\*|__|~~|\*|_)(?!\s)(.+?)(?<![\s\\])\1(?!\w)/g, "$2")
        .replace(/`([^`]*)`/g, "$1")
        // A cut-off link at the end, an empty one, a rule or table border, an escape.
        .replace(/!?\[([^\]]*)\]\([^)]*$/, "$1")
        .replace(/!?\[([^\]]*)$/, "$1")
        .replace(/\[\s*\]/g, "")
        .replace(/^[\s|:=*_-]{3,}$/gm, "")
        .replace(/&nbsp;/g, " ")
        .replace(/\\([\\`*_{}[\]()#+\-.!<>|~&=])/g, "$1")
        .replace(/\s+/g, " ")
        .trim();
}
/**
 * An article's first real paragraph, for a card: past the logos, nav links and
 * one-line chrome ("From Wikipedia, the free encyclopedia") a scrape opens with.
 * Real means a sentence of eight words or more, never a table (an infobox);
 * else the first non-empty one. Cut at a word near `max`; the card clamps and
 * adds the ellipsis.
 */
export function lede(markdown, max = 240) {
    const paragraphs = markdown.split(/\n\s*\n/).filter((p) => !p.trimStart().startsWith("|")).map(plainText).filter(Boolean);
    const text = paragraphs.find((p) => p.split(" ").length >= 8 && /[.!?,;:]/.test(p)) ?? paragraphs[0] ?? "";
    const cut = text.lastIndexOf(" ", max);
    return text.length <= max ? text : text.slice(0, cut > 0 ? cut : max);
}
/**
 * A date from ISO or from X's legacy `Thu Oct 08 20:04:10 +0000 2026`, which V8 reads and Hermes
 * does not (2026-10-28). An unreadable one is an Invalid Date, never a throw.
 */
export function toDate(value) {
    const x = value.match(/^\w{3} (\w{3}) (\d{2}) ([\d:]{8}) ([+-]\d{2})(\d{2}) (\d{4})$/);
    const month = x && String("JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(x[1]) / 3 + 1).padStart(2, "0");
    return new Date(x ? `${x[6]}-${month}-${x[2]}T${x[3]}${x[4]}:${x[5]}` : value);
}
/**
 * A note's `# ` title line and the body under it (block 47). No `# ` line means
 * no title. The title is plain text, never markdown.
 */
export function splitNote(text) {
    const match = text?.match(/^# (.*)\n*/);
    return match ? { title: match[1].trim(), body: text.slice(match[0].length) } : { title: "", body: text ?? "" };
}
/** A body opening with a literal `# ` is escaped, or it would read back as the title. */
export const joinNote = (title, body) => [title.trim() && `# ${title}`, body.replace(/^# /, "\\# ")].filter(Boolean).join("\n\n");
//# sourceMappingURL=text.js.map